<template>
    <div v-if="hasPermission('create_member_session_booking')" class="modal fade" id="modal_add_session_booking" tabindex="-1" data-bs-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestBooking" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t("views.clients.sessionBooking.add") }}
                    </h5>
                    <button @click="handleCloseModal" type="button" class="btn-close" aria-label="btn-close"></button>
                </div>
                <div class="modal-body">

                    <!-- information income (rocette) -->
                    <informations-income />
                    <!-- end information income (rocette) -->


                    <div v-if="income && income?.remaining_sessions === 0" class="row">
                        <div class="col-md-12">
                            <div class="message message-expired">
                                <p><b>Session de coaching impossible</b></p>
                                <p>Toutes les séances de coaching ont été utilisées. Veuillez renouveler votre
                                    abonnement pour pouvoir réserver de nouvelles séances.</p>
                            </div>
                        </div>
                    </div>
                    <div v-else class="row  ">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <h5>{{ i18n.t("views.clients.sessionBooking.choose_slot") }}</h5>
                                        </div>
                                    </div>

                                    <!-- Filters Form -->
                                    <div class="row">
                                        <loader-gif v-if="isRequestTrainer" />
                                        <div class="col-12">
                                            <form class="forms-sample" @submit.prevent="fetchDataReservedSlots">
                                                <div class="row">
                                                    <div class="col-md-12 mb-2">
                                                        <SingleSelect v-model="searchByReservedSlots.trainer_id"
                                                            :TextLabel="i18n.t('tables.session.trainer')"
                                                            :arrayOptions="trainersList"
                                                            :placeholder="i18n.t('tables.session.trainer')"
                                                            :trackby="'id'" :valueProp="'id'" :label="'name'" />
                                                    </div>
                                                    <div class="col-12 col-md-6 mb-2">
                                                        <div class="form-group mr-b-0em">
                                                            <DateField v-model="searchByReservedSlots.start_date"
                                                                :label="i18n.t('tables.subscription_member.start_date')"
                                                                :disabled="false" :fixedDays="0" :isFixedDays="false" />
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-md-6 mb-2">
                                                        <div class="form-group mr-b-0em">
                                                            <DateField v-model="searchByReservedSlots.end_date"
                                                                :label="i18n.t('tables.subscription_member.end_date')"
                                                                :disabled="false" :fixedDays="0" :isFixedDays="false" />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-12 d-flex flex-column flex-md-row justify-content-end gap-2">
                                                        <button type="submit" class="btn btn-search">
                                                            <font-awesome-icon icon="fa-search" size="lg"
                                                                class="link-icon" />
                                                            {{ i18n.t("button.search") }}
                                                        </button>
                                                        <button type="button" class="btn btn-cancel"
                                                            @click="handleCloseModal">
                                                            {{ i18n.t("button.cancel") }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div v-if="hasSearched" class="col-12">
                                            <h6 class="text-center p-2">
                                                {{ i18n.t("views.clients.sessionBooking.date_range") }}
                                                <strong>{{ formatDate(searchByReservedSlots.start_date) }}</strong>
                                                {{ i18n.t("views.clients.sessionBooking.to") }}
                                                <strong>{{ formatDate(searchByReservedSlots.end_date) }}</strong>
                                            </h6>
                                            <h5 class="text-center p-3">
                                                <strong>{{
                                                    i18n.t("views.clients.sessionBooking.trainer_availability")
                                                }}</strong>
                                            </h5>
                                        </div>

                                        <!-- Calendar -->
                                        <div v-if="!hasSearched" class="text-center mt-5">
                                            Veuillez effectuer une recherche
                                        </div>

                                        <div v-else class="col-12 position-relative mt-3">
                                            <div class="w-100 overflow-auto">
                                                <vue-cal class="vuecal--blue-theme w-100" default-view="week"
                                                    active-view="week"
                                                    :disable-views="['years', 'year', 'month', 'day']"
                                                    :min-date="minDate" :max-date="maxDate" :time-from="5 * 60"
                                                    :time-to="23 * 60" :events="events" locale="fr"
                                                    :hide-weekends="false" :on-event-click="handleEventClick"
                                                    :selected-date="viewDate" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, toRefs, watch } from "vue";
import router from "@/router/index";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import VueCal from "vue-cal";
import DateField from "@/components/inputsValidation/DateField.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";


import { useModal } from "@/composables/modal/useModal";
import { usePermission } from "@/composables/auth/usePermission";
import { useGlobal } from "@/composables/global/useGlobal";
import { useTrainer } from "@/composables/trainer/useTrainer";
import { useSessionBookings } from "@/composables/sessionBooking/useSessionBookings";
import { clubUUID, trainers, singleIncome } from "@/shared/state";
import type {
    StoreBookingPayload,
} from "@/interfaces/sessionBooking";
import type { Trainer, ReservedSlotsResponseItem } from "@/interfaces/trainer";




const WORK_START_HOUR = 5;
const WORK_END_HOUR = 23;

function timeToMinutes(time: string): number {
    const [h, m] = (time || "00:00").split(":").map(Number);
    return (h ?? 0) * 60 + (m ?? 0);
}

function minutesToTime(min: number): string {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
}

function slotsOverlap(
    start1: string,
    end1: string,
    start2: string,
    end2: string
): boolean {
    const s1 = timeToMinutes(start1);
    const e1 = timeToMinutes(end1);
    const s2 = timeToMinutes(start2);
    const e2 = timeToMinutes(end2);
    return s1 < e2 && e1 > s2;
}

export default defineComponent({
    name: "add-trainer-session-booking",
    components: { DateField, VueCal, SingleSelect },

    emits: ['saved'],
    props: {
        sessionBooking: { type: Object, default: null },
        memberUUID: { type: String, default: null },

    },

    setup(props, { emit }) {
        const { sessionBooking, memberUUID } = toRefs(props);
        const income = computed(() => singleIncome.data);
        const { closeModal } = useModal();
        const { hasPermission } = usePermission();
        const { formatDate, formatTime, formatDay } = useGlobal();
        const { fetchReservedSlots, isRequestTrainer } = useTrainer();
        const { createBooking, isRequestBooking } = useSessionBookings();
 
        const trainersList = computed(() => trainers.data);






        const reservedSlotsData = ref<ReservedSlotsResponseItem[]>([]);
        const hasSearched = ref(false);
        const viewDate = ref(new Date());
        const minDate = dayjs().startOf("month").toDate();
        const maxDate = dayjs().add(1, "month").endOf("month").toDate();

        const searchByReservedSlots = ref({
            start_date: dayjs().format("YYYY-MM-DD"),
            end_date: dayjs().add(1, "week").format("YYYY-MM-DD"),
            trainer_id: null
        });

        const reservedByDate = computed(() => {
            const map: Record<string, { start_time: string; end_time: string }[]> = {};
            reservedSlotsData?.value?.forEach((item) => {
                map[item.date] = item.slots.map((s) => ({
                    start_time: s.start_time,
                    end_time: s.end_time,
                }));
            });
            console.log("map")
            console.log(map)
            return map;
        });


        const trainerName = computed(() => {
            return trainersList.value.find(
                (trainer: Trainer) => trainer.id === searchByReservedSlots.value.trainer_id
            )?.name ?? '';
        });
        watch(
            () => searchByReservedSlots.value.trainer_id,
            (val) => {
                hasSearched.value = false;
                reservedSlotsData.value = [];
            }
        );



        const events = computed(() => {
            const all: any[] = [];

            const start = searchByReservedSlots.value.start_date;
            const end = searchByReservedSlots.value.end_date;

            if (!start || !end) return [];

            // ✅ Return empty array if no data
            // if (
            //   !reservedByDate.value ||
            //   Object.keys(reservedByDate.value).length === 0
            // ) {
            //   return [];
            // }

            let d = dayjs(start);
            const endD = dayjs(end);

            while (!d.isAfter(endD)) {
                const dateStr = d.format("YYYY-MM-DD");
                const reserved = reservedByDate.value?.[dateStr] ?? [];

                reserved.forEach((slot) => {
                    all.push({
                        title: i18n.t("views.clients.sessionBooking.reserved"),
                        start: `${dateStr} ${slot.start_time}`,
                        end: `${dateStr} ${slot.end_time}`,
                        class: "event-reserved",
                        status: "reserved",
                        date: dateStr,
                        start_time: slot.start_time,
                        end_time: slot.end_time,
                    });
                });

                for (let h = WORK_START_HOUR; h < WORK_END_HOUR; h++) {
                    const slotStart = minutesToTime(h * 60);
                    const slotEnd = minutesToTime((h + 1) * 60);

                    const overlaps = reserved.some((r) =>
                        slotsOverlap(slotStart, slotEnd, r.start_time, r.end_time)
                    );

                    if (!overlaps) {
                        all.push({
                            title: i18n.t("views.clients.sessionBooking.available"),
                            start: `${dateStr} ${slotStart}`,
                            end: `${dateStr} ${slotEnd}`,
                            class: "event-available",
                            status: "available",
                            date: dateStr,
                            start_time: slotStart,
                            end_time: slotEnd,
                        });
                    }
                }

                d = d.add(1, "day");
            }

            return all;
        });
        const fetchDataReservedSlots = async () => {

            if (!searchByReservedSlots?.value?.trainer_id)
                return false;

            hasSearched.value = false;
            reservedSlotsData.value = [];
            const start = searchByReservedSlots.value.start_date;
            const end = searchByReservedSlots.value.end_date;
            if (!start || !end) return;

            const res = await fetchReservedSlots({
                trainer_id: searchByReservedSlots?.value?.trainer_id ?? null,
                session_date: [start, end],
                clubUUID: clubUUID.value,
            });
            reservedSlotsData.value = res ?? [];
            hasSearched.value = true;
        };

        const handleEventClick = (event: any) => {
            if (event?.status !== "available") return;
            const carnet = income.value;
            if (!carnet) return;

            Swal.fire({
                title:
                    i18n.t("message.confirmation.reserve.title") +
                    " " + trainerName.value,
                text:
                    formatDate(event?.date) +
                    " " +
                    i18n.t("views.clients.sessionBooking.from") +
                    " " +
                    formatTime(event?.start_time) +
                    " " +
                    i18n.t("views.clients.sessionBooking.to") +
                    " " +
                    formatTime(event?.end_time),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: i18n.t("button.yes"),
                cancelButtonText: i18n.t("button.cancel"),
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const payload: StoreBookingPayload = {
                        income_id: carnet.id,
                        trainer_id: searchByReservedSlots?.value?.trainer_id ?? null,
                        member_id: carnet.member_id,
                        session_date: event.date,
                        start_time: formatTime(event.start_time) ?? event.start_time,
                        end_time: formatTime(event.end_time) ?? event.end_time,
                    };
                    const created = await createBooking(payload);
                    if (created) {
                        emit('saved');
                        handleCloseModal();

                    }
                }
            });
        };

        const emptyStatesModal = () => {
            reservedSlotsData.value = [];
            hasSearched.value = false;
            searchByReservedSlots.value = {
                start_date: dayjs().format("YYYY-MM-DD"),
                end_date: dayjs().add(1, "week").format("YYYY-MM-DD"),
                trainer_id: null
            };
            viewDate.value = new Date();
        };

        const handleCloseModal = () => {
            emptyStatesModal();
            closeModal("modal_add_session_booking", "add");
        };


        onMounted(() => {
            const modalEl = document.getElementById("modal_add_session_booking");
            modalEl?.addEventListener("hidden.bs.modal", () => {
                emptyStatesModal();
            });
        });

        return {
            income,
            isRequestBooking,
            isRequestTrainer,
            i18n,
            handleCloseModal,
            hasPermission,
            formatDate,
            formatTime,
            formatDay,
            searchByReservedSlots,
            reservedSlotsData,
            events,
            viewDate,
            minDate,
            maxDate,
            hasSearched,
            fetchDataReservedSlots,
            handleEventClick,
            trainersList
        };
    },
});
</script>
